import React from "react";
import Title from "../../../components/Title/Title";

const FullAgenda2027page = () => {
    return (
        <div>
            <Title>Full Agenda</Title>
            <p>[COMING SOON]</p>
        </div>
    )
}

export default FullAgenda2027page;
